import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/Inputs/Button/Button';
import closeButtonPic from '../../../assets/designSystem/icons/close.svg';
import phone from '../../../assets/designSystem/icons/icon_phone.png';
import './popup.css';

export default function abnormalMovement({ babyOrChild, callback }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="modal__backdrop" />
      <div className="modal__popup">
        <div className="popup__container">
          <img
            src={closeButtonPic}
            alt="close button"
            className="popup__closeBtn"
            role="presentation"
            width="24"
            onClick={callback}
          />
          <div className="popup__content">
            <h4 className="popup__title">{t(`popUps.abnormalMovement.${babyOrChild}.title`)}</h4>
            <p>{t(`popUps.abnormalMovement.${babyOrChild}.p1`)}</p>
            <p>{t(`popUps.abnormalMovement.${babyOrChild}.p2`)}</p>
            <div className="popup__numbers">
              <a href="tel:0800721316" className="phone__btn__button">
                <span>
                  <img src={phone} alt="phone icon" />
                </span>
                <span>
                  <p className="phone__btn__number">{t('popUps.ambulance.number1')}</p>
                </span>
              </a>
            </div>
          </div>
          <div className="popup__button">
            <Button width="fullWidth" hierarchy="primary" onClick={callback}>
              {t('popUps.button')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
